<template>
  <div class="">hello wordld</div>
</template>

<script>
import { PostChukouECode } from "@/utils/api";
export default {
  methods: {
    init() {
        PostChukouECode({
            Code:this.$route.query.code,
            UserCode:sessionStorage.getItem("UserCode"),
            HeaderStr:sessionStorage.getItem("HeaderStr"),
        }).then(res=>{
            if(res){
                this.$router.push({
                    path:"/logisticsAcc"
                })
            }
        })
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="less" scoped>
</style>
